import { Record, Set as ImmutableSet } from 'immutable';
const Account = Record({
  accountName: null,
  accountType: null,
  domain: null,
  id: 0,
  numberOfUsers: 0,
  numberOfContacts: 0,
  obscured: false,
  products: ImmutableSet(),
  cookieWeight: 0,
  disabled: false,
  appDomain: null,
  hublet: null
}, 'Account');
export default Account;